import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { NavigationIcons } from './IconMap';
import './BottomNavbar.css';

const BottomNavbar = () => {
  const location = useLocation();

  // Navigation items with their routes and labels
  const navItems = [
    { path: '/', icon: 'home', label: 'Home' },
    { path: '/boxoffice', icon: 'boxoffice', label: 'Box Office' },
    { path: '/upcoming', icon: 'upcoming', label: 'Upcoming' },
    { path: '/news', icon: 'news', label: 'News' },
  ];

  // In BottomNavbar.jsx, update the return statement
  return (
    <nav className="bottom-navbar">
      {navItems.map((item) => {
        const isCurrentRoute = location.pathname === item.path;

        const handleNavClick = (e) => {
          if (isCurrentRoute) {
            e.preventDefault();
            // Custom faster smooth scroll
            const duration = 250; // Faster duration (in ms) - adjust this value to your preference
            const start = window.scrollY;
            const startTime = performance.now();

            function animate(currentTime) {
              const elapsed = currentTime - startTime;
              const progress = Math.min(elapsed / duration, 1);

              // Using easeOutQuad for a natural feel
              const easeOutQuad = t => 1 - (1 - t) * (1 - t);

              window.scrollTo(0, start * (1 - easeOutQuad(progress)));

              if (progress < 1) {
                requestAnimationFrame(animate);
              }
            }

            requestAnimationFrame(animate);
          }
        };

        return (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={handleNavClick}
          >
            {NavigationIcons[item.icon](isCurrentRoute)}
            <span>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default BottomNavbar;